module.exports = __webpack_public_path__ + "img/brilliange_logo@2x.b06d818b.png";